import {
  NormalQuestionBubble,
  QuestionBubbleHeader,
  QuestionBubbleLabel,
} from "@/Shared/Components/QuestionBubble";

function LoadingCapabilitiesQuestionBubble() {
  return (
    <NormalQuestionBubble
      description={
        <>
          <QuestionBubbleHeader>Loading Capabilities</QuestionBubbleHeader>
          <QuestionBubbleLabel>
            Knowing whether your location has loading capabilities like a dock
            or forklift helps us coordinate your shipment more effectively. This
            information allows carriers to prepare the right equipment and
            personnel for pickup or delivery.
          </QuestionBubbleLabel>
        </>
      }
      learnMoreUrl="https://help.freightsimple.com/using-freightsimple/booking-your-shipment/confirming-your-loading-or-offloading-method"
    />
  );
}
export default LoadingCapabilitiesQuestionBubble;
